<template>
<!-- 获取与修改经纬度组件 -->
<div>
  <div id="map"></div>
</div>
 
</template>
<script>
let map=null
let marker=null
export default {
  props:{
    long:{
      type:String
    },
    lan:{
      type:String
    }
  },
  data(){
    return{
      GoogleMapLat:Number(this.lan),
      GoogleMapLng:Number(this.long)
    }
  },
  mounted(){
    //创建地图,获取父组件传输的设备经纬度
    this.initMap(Number(this.lan),Number(this.long))
  },
  methods:{
    //载入地图
    initMap(lat,lng) {
      map=null
      marker=null
      //创建地图
      map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: lat, lng: lng},
          zoom: 8
        });
        //添加点
      marker = new google.maps.Marker({position: {lat: lat, lng: lng}, map: map})
      //获取点击经纬度
      map.addListener('click',(e)=>{
        //获取到lat
        this.GoogleMapLat=e.latLng.lat()
        //获取到lng
        this.GoogleMapLng=e.latLng.lng()
        //修改点坐标
        marker.setPosition({lat:this.GoogleMapLat,lng:this.GoogleMapLng})
      })
    },
    //修改上传经纬度信息
    GetMap(){
      //父组件调用该函数获取到经纬度信息上传
      return {long:this.GoogleMapLng,lan:this.GoogleMapLat}
    },
    //重置按钮
    ResetLatLng(){
      marker.setPosition({lat:Number(this.lan),lng:Number(this.long)})
    }
  }
}
</script>
<style scoped>
#map {
        width: 100%;
        margin: 0 auto;
        display: inline-block;
        height: 50vh;
    }
</style>
